import { render, staticRenderFns } from "./CardTokensStats.vue?vue&type=template&id=17ebda6d&"
import script from "./CardTokensStats.vue?vue&type=script&lang=js&"
export * from "./CardTokensStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ebda6d')) {
      api.createRecord('17ebda6d', component.options)
    } else {
      api.reload('17ebda6d', component.options)
    }
    module.hot.accept("./CardTokensStats.vue?vue&type=template&id=17ebda6d&", function () {
      api.rerender('17ebda6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/CardTokensStats.vue"
export default component.exports